import type { CheckoutThemedHtml, ThemedHtml } from '@trmediaab/zebra';

import anchor from './anchor';
import heading from './heading';
import text from './text';

const html: ThemedHtml<CheckoutThemedHtml> = {
  common: {
    a: anchor.variants.default,
    h2: { ...heading.common, ...heading.h2.variants.default },
    h3: { ...heading.common, ...heading.h3.variants.default },
    strong: text.strong.variants.default,
    i: text.em.variants.default,
    'ol, ul': {
      display: 'grid',
      gap: 2,
    },
    'ol li, ul li': {
      display: 'grid',
      gridTemplateColumns: '0 1fr',
      gap: '3,5',
      alignItems: 'start',
    },
    'ul li::before': {
      content: "'•'",
      color: 'primary',
      transform: 'scale(2.5)',
    },
    ol: {
      counterReset: 'list-counter',
    },
    'ol li': {
      counterIncrement: 'list-counter',
    },
    'ol li::before': {
      content: 'counter(list-counter) "."',
      color: 'primary',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    '& .editor__fineprint': {
      color: 'text.faded',
      fontSize: 1,
    },
    '& .editor__highlight, mark': {
      backgroundColor: 'text.highlight',
    },
  },
  variants: {
    checkoutSmall: {
      '*': {
        fontSize: [0, null, 1],
        lineHeight: 'medium',
      },
      '& .editor__fineprint': {
        fontSize: 0,
      },
    },
  },
};

export default html;
